export default __webpack_public_path__ + "media/images/29-96c7a6fa3e4fcafb7845133d80f68914.jpg";